import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../../FormLegacy/FormFieldsV2/TextAreaField'
import Icon from '../../../Icons'

const CompleteRequestModal = ({
  updateCompleteMaintenanceRequestData,
  handleCancel,
  jobSummaryMessage,
  setJobSummaryMessage,
}) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const completeMaintenanceRequest = () => {
    updateCompleteMaintenanceRequestData({
      jobSummaryMessage,
      status: 'Finished',
      completedDate: Date.now(),
    })
    handleCancel()
  }

  return (
    <div className="maintenance-request-add-note">
      <div className="maintenance-request-add-note__container">
        <div className="window-header">
          <div className="title">{t('maintenance:requestPreview.completeModal.title')}</div>
          <div className="navi-button" onClick={() => handleCancel()}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">
          <TextAreaField
            name={'jobSummaryMessage'}
            placeholder={t('maintenance:requestPreview.jobSummary.message.placeholder')}
            label={t('maintenance:requestPreview.jobSummary.message.label')}
            value={jobSummaryMessage}
            onChange={(e) => setJobSummaryMessage(e.target.value)}
            maxLength="500"
            style={{ width: '100%' }}
          />
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button className={'button button-gray is-block'} onClick={() => handleCancel()}>
              {t('common:actions.cancel')}
            </button>
            <button
              onClick={() => completeMaintenanceRequest()}
              className={'button button-primary is-block'}
              disabled={!jobSummaryMessage}
            >
              {t('common:actions.save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

CompleteRequestModal.propTypes = {
  handleCancel: PropTypes.func,
  jobSummaryMessage: PropTypes.string,
  setJobSummaryMessage: PropTypes.func,
  updateCompleteMaintenanceRequestData: PropTypes.func,
  maintenanceId: PropTypes.number,
}

export default CompleteRequestModal
